import { subDays } from 'date-fns';
import { GetNotificationSettingsResult, GetNotificationsResult, NotificationParameterFlags, NotificationType } from '../api';
import { GetUnreadNotificationsCountResult } from '../api/models/get-unread-notifications-count-result';
import { NotificationDto } from '../api/models/notification-dto';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';
import { MOCK_SCORP_ANTI_GASPI_RESTAURANT_ID } from './mock-restaurants';

function createNotification(
  type: NotificationType,
  date: Date,
  id: number,
  read: boolean,
  description: string,
  enqueteResponseId?: number,
  echangeId?: number,
  restaurantId?: number,
) {
  const notification: NotificationDto = {
    date: date.toString(),
    id,
    read,
    type,
    description,
    title: '',
    enqueteResponseId,
    echangeId,
    restaurantId,
  };
  return notification;
}

interface NotificationProps {
  lue: boolean;
  type: NotificationType;
  description: string;
  enqueteResponseId?: number;
  echangeId?: number;
  restaurantId?: number;
}

const PROPS: NotificationProps[] = [
  {
    lue: false,
    type: NotificationType.AntiGaspi,
    description: 'Notif Mock AntiGaspi',
    restaurantId: MOCK_SCORP_ANTI_GASPI_RESTAURANT_ID,
  },
  {
    lue: false,
    type: NotificationType.Echange,
    description: 'Une réponse a votre dernier message !',
    echangeId: 1,
  },
  {
    lue: false,
    type: NotificationType.AlerteSolde,
    description: 'Votre solde est bas, veuillez recharger',
  },
  {
    lue: false,
    type: NotificationType.Commande,
    description: 'Votre commande est disponible',
  },
  {
    lue: true,
    type: NotificationType.Paiement,
    description: 'Paiement de 50,00 €\r\nRéférence : 8237212',
  },
  {
    lue: true,
    type: NotificationType.Favoris,
    description: 'Venez manger des crêpes !',
  },
  {
    lue: true,
    type: NotificationType.EnqueteReponse,
    description: 'Suite à votre avis du 24/03/2023, consulter la réponse de votre responsable de restaurant',
    enqueteResponseId: 3,
  },
];

function createNotifications() {
  const today = new Date();
  const notifications: NotificationDto[] = [];
  for (let i = 0; i < 13; i++) {
    const props = PROPS[i % 6];
    notifications.push(
      createNotification(props.type, subDays(today, 12 - i), i, props.lue, props.description, props.enqueteResponseId, props.echangeId, props.restaurantId),
    );
  }
  return notifications.reverse();
}

export const MOCK_NOTIFICATIONS_OK_PAGE0: GetNotificationsResult = {
  hasMore: true,
  notifications: createNotifications().slice(0, 9),
};

export const MOCK_NOTIFICATIONS_OK_PAGE1: GetNotificationsResult = {
  hasMore: false,
  notifications: createNotifications().slice(10, 12),
};

export const MOCK_GET_SETTINGS_OK: GetNotificationSettingsResult = {
  notificationSettings: [
    { category: NotificationParameterFlags.Animation, emailEnabled: true, smsEnabled: true, pushEnabled: true },
    { category: NotificationParameterFlags.Enquete, emailEnabled: true, smsEnabled: true, pushEnabled: true },
    { category: NotificationParameterFlags.AlerteSolde, emailEnabled: true, smsEnabled: true, pushEnabled: true },
    { category: NotificationParameterFlags.Echange, emailEnabled: true, smsEnabled: true, pushEnabled: true },
    { category: NotificationParameterFlags.Paiement, emailEnabled: false, smsEnabled: false, pushEnabled: false },
    { category: NotificationParameterFlags.ResultatVote, emailEnabled: false, smsEnabled: false, pushEnabled: false },
    { category: NotificationParameterFlags.DinerTakeAway, emailEnabled: false, smsEnabled: false, pushEnabled: false },
    { category: NotificationParameterFlags.Commande, emailEnabled: false, smsEnabled: false, pushEnabled: false },
  ],
  acceptEliorOffers: false,
  acceptPartnersOffers: true,
};

export const MOCK_GET_COUNT_OK: GetUnreadNotificationsCountResult = {
  count: 6,
};

export const MOCK_NOTIFICATIONS = {
  OK_PAGE0: MOCK_NOTIFICATIONS_OK_PAGE0,
  OK_PAGE1: MOCK_NOTIFICATIONS_OK_PAGE1,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_DELETE_NOTIFICATION = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_GET_NOTIFICATION_SETTINGS = {
  OK: MOCK_GET_SETTINGS_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_UPDATE_NOTIFICATION_SETTINGS = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_UPDATE_OPTIN_SETTINGS = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_NOTIFICATION_AS_READ = {
  OK: true,
};

export const MOCK_GET_NOTIFICATION_COUNT = {
  OK: MOCK_GET_COUNT_OK,
};
